/**
 * Traduz um valor de enum vindo da Api (ex.: "Active", "Owner") usando um mapa de rotulos
 * i18n. Cai no valor bruto quando o backend introduzir um valor novo ainda sem traducao,
 * em vez de quebrar a tela.
 */
export function translateEnumValue(
  labels: Readonly<Record<string, string>>,
  value: string,
): string {
  return labels[value] ?? value
}

export function formatDate(value: string, language: string): string {
  const date = new Date(value)

  if (Number.isNaN(date.getTime())) {
    return value
  }

  return new Intl.DateTimeFormat(language, { dateStyle: 'long' }).format(date)
}
